import guid from 'modules/guid'

import { NOTIFICATIONS_INLINE_ADD, NOTIFICATIONS_INLINE_KEEP_OPEN, NOTIFICATIONS_INLINE_REMOVE, NOTIFICATIONS_INLINE_REMOVE_ALL, NOTIFICATIONS_INLINE_REMOVE_TIMEOUT } from 'Notifications/NotificationsInline/constants'

export const notificationsInlineAdd = payload => ({ payload: { ...payload, uuid: guid() }, type: NOTIFICATIONS_INLINE_ADD })
export const notificationsInlineKeepOpen = payload => ({ payload, type: NOTIFICATIONS_INLINE_KEEP_OPEN })
export const notificationsInlineRemove = payload => ({ payload, type: NOTIFICATIONS_INLINE_REMOVE })
export const notificationsInlineRemoveAll = payload => ({ payload, type: NOTIFICATIONS_INLINE_REMOVE_ALL })
export const notificationsInlineRemoveTimeout = payload => ({ payload, type: NOTIFICATIONS_INLINE_REMOVE_TIMEOUT })
